import './styles.css';

const gccsPopupInviteEmployeeMessage = {
  controller: 'PopupInviteEmployeeMessageController',
  template: require('./template.pug'),
  require: {
    gccsPopupsLayout: '^gccsPopupsLayout'
  },
  bindings: {
    employee: '<'
  }
};

angular.module('shared-components').component('gccsPopupInviteEmployeeMessage', gccsPopupInviteEmployeeMessage);
